import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { gsap } from 'gsap';

import { FilterWrap, FilterLabel } from './styles';
import { getDestinationOptions } from './index';
import classnames from 'classnames';
import { PORT } from 'contexts/CruiseSearchContext/constants';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useFeatureFlags } from '../../../../hooks/LaunchDarkly/useFeatureFlags';

/**
 * DestinationFilters
 *
 * @param {string} allowingOption - ?
 * @param {func} setAllowingOption - ?
 */

const DestinationFilters = ({ allowingOption, setAllowingOption }) => {
	const filtersRef = useRef();
	const { globalization } = useContext(CruiseSearchContext);
	const { showAllPortsFilter } = useFeatureFlags();
	const { itineraryCardsDictionary, filtersDictionary } = globalization?.dictionaries || {};
	const { labelDestinationsHeader } = filtersDictionary;

	const { labelPorts } = itineraryCardsDictionary;

	const DESTINATION_OPTIONS = getDestinationOptions(labelDestinationsHeader, labelPorts);

	useEffect(() => {
		const els = filtersRef.current?.children || [];
		gsap.from(els, {
			duration: 0.75,
			opacity: 0,
			y: '10px',
			ease: 'power2.inOut',
			stagger: 0.25,
		});
	}, []);

	return (
		<FilterWrap ref={filtersRef}>
			{Object.keys(DESTINATION_OPTIONS)
				.filter((option) => (showAllPortsFilter ? option : option !== PORT))
				.map((key) => {
					const { key: destKey, label, filterName } = DESTINATION_OPTIONS[key];
					return (
						<FilterLabel key={key} className={classnames({ active: allowingOption === destKey })} onClick={() => setAllowingOption(filterName)}>
							{label}
						</FilterLabel>
					);
				})}
		</FilterWrap>
	);
};

DestinationFilters.propTypes = {
	allowingOption: PropTypes.string.isRequired,
	setAllowingOption: PropTypes.func.isRequired,
};

export default DestinationFilters;
